import React from "react";
import { DatePicker, Form, Input, InputNumber, Radio, Table } from "antd";
import dayjs from "dayjs";

const { TextArea } = Input;

const plainOptions = ["Yes", "No"];

function ContractInfoSection({
  mrAdvancePaymentAvailable,
  dlp,
  payments,
  pendingCount,
  paymentColumns,
  advanceRecovered,
}) {
  return (
    <>
      <div className="custom-title !bg-white !p-0 mt-[1.25rem]">
        Contract Information
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="mrContractorName"
          label={"Contractor Name"}
          rules={[
            {
              required: true,
              message: "Please add contractor name",
            },
          ]}
        >
          <Input disabled className="input" />
        </Form.Item>

        <Form.Item
          name="mrContractSum"
          label="Contract Sum"
          rules={[
            {
              required: true,
              message: "Please add contract sum",
            },
          ]}
        >
          <InputNumber
            disabled
            suffix="Kes."
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item
          label="Contract Award Date"
          name="mrContractAwardDate"
          rules={[
            {
              required: false,
              message: "Contract award date is required",
            },
          ]}
        >
          <DatePicker disabled format={"YYYY MMM DD"} className="input" />
        </Form.Item>
        <Form.Item
          label={"Advance Payment  available ? "}
          name="mrAdvancePaymentAvailable"
          rules={[
            {
              required: true,
              message: "Required field",
            },
          ]}
        >
          <Radio.Group disabled options={plainOptions} />
        </Form.Item>
        {mrAdvancePaymentAvailable === "Yes" && (
          <>
            <Form.Item
              name="mrAmountPaidAdvance"
              label="Amount paid in Advance"
              rules={[
                {
                  required: true,
                  message: "Please add amount paid in Advance",
                },
              ]}
            >
              <InputNumber
                disabled
                suffix="Kes."
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                placeholder="Enter value"
                className="input flex"
              />
            </Form.Item>
            <Form.Item
              label="Date of Advance Amount Paid"
              name="mrAmountPaidAdvanceDate"
              rules={[
                {
                  required: true,
                  message: "Date of advance amount paid is required",
                },
              ]}
            >
              <DatePicker disabled format={"YYYY MMM DD"} className="input" />
            </Form.Item>
            {/* Calculated from the payments (Advance Repayment Amount on the
                project's Payment tab). No "name": shown, not editable, not
                saved - the report works it out the same way. */}
            <Form.Item
              label="Advance Payment Recovered"
              tooltip="Total Advance Repayment Amount across the project's payments"
            >
              <InputNumber
                disabled
                value={advanceRecovered ?? 0}
                suffix="Kes."
                formatter={(value) =>
                  `${value ?? ""}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                className="input flex"
              />
            </Form.Item>
          </>
        )}
        {dlp && (
          <>
            <Form.Item label={"Defect Liability Period"}>
              {dlp.has === "Yes" ? (
                <Radio.Group disabled options={plainOptions} value="Yes" />
              ) : (
                <span className="text-[#6B7280]">
                  {dlp.has === "No"
                    ? "This project has no Defect Liability Period"
                    : "Not set on the project"}
                </span>
              )}
            </Form.Item>
            {dlp.has === "Yes" && (
              <>
                <Form.Item label="DLP Start Date">
                  <DatePicker
                    disabled
                    format={"YYYY MMM DD"}
                    className="input"
                    value={dlp.start ? dayjs(dlp.start) : null}
                  />
                </Form.Item>
                <Form.Item label="DLP End Date">
                  <DatePicker
                    disabled
                    format={"YYYY MMM DD"}
                    className="input"
                    value={dlp.end ? dayjs(dlp.end) : null}
                  />
                </Form.Item>
                <Form.Item label={"Defect Liability Period (Days)"}>
                  <InputNumber
                    disabled
                    value={dlp.days}
                    formatter={(value) =>
                      `${value ?? ""}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    className="input flex"
                  />
                </Form.Item>
              </>
            )}
          </>
        )}
        <Form.Item
          name="mrAmountPaid"
          label="Amount Paid to Date"
          rules={[
            {
              required: false,
              message: "Please add amount paid to date",
            },
          ]}
        >
          <InputNumber
            disabled
            suffix="Kes."
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item
          name="mrRaisedIpcs"
          label="Number of Raised IPCs"
          tooltip="All payments on the project (see the table below)"
          rules={[
            {
              required: true,
              message: "Please add raised IPCs",
            },
          ]}
        >
          <InputNumber
            disabled
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item
          name="mrPendingIpcs"
          label="Number of IPCs Pending Payment"
          tooltip="Payments with status Pending Payment (see the table below)"
          rules={[
            {
              required: true,
              message: "Please add IPCs Pending Payment",
            },
          ]}
        >
          <InputNumber
            disabled
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <div className="lg:col-span-2 mb-[1.5rem]">
          <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
            <span className="font-interSans text-[.875rem] font-[500] text-[#050505]">
              IPC Payments
            </span>
            <span className="font-interSans text-[.75rem] text-[#6B7280]">
              Raised: {payments.length} &nbsp;|&nbsp; Pending Payment:{" "}
              {pendingCount(payments)} &nbsp;|&nbsp; Paid:{" "}
              {payments.length - pendingCount(payments)}
            </span>
          </div>
          <Table
            rowSelection={false}
            size="small"
            scroll={{ x: "max-content" }}
            rowKey={(record) => record?.disbursementId}
            columns={paymentColumns}
            dataSource={payments}
            pagination={{
              pageSize: 5,
              hideOnSinglePage: true,
              showSizeChanger: false,
            }}
            locale={{ emptyText: "No payments recorded for this project" }}
          />
        </div>
        <Form.Item
          name="mrContractSumBalance"
          label="Balance of the Contract Sum"
          rules={[
            {
              required: true,
              message: "Please add balance of the contract sum",
            },
          ]}
        >
          <InputNumber
            disabled
            suffix="Kes."
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item
          name="mrScope"
          label={"Scope"}
          rules={[
            {
              required: true,
              message: "Please add scope",
            },
          ]}
        >
          <TextArea disabled className="text_area" />
        </Form.Item>
      </div>
    </>
  );
}

export default ContractInfoSection;
